import { send } from '@giantmachines/redux-websocket';

import { PREFIX } from './constants';

export default (data) => send(data, PREFIX);
